import { podeFiscalizar } from '../../auth/permissoes'
import type { UsuarioLogado } from '../../types/gmud'

/**
 * Quem pode ESCREVER ordem de serviço — registrar, revogar, registrar fato.
 *
 * **Leitura é dos dois lados do contrato; escrita é só da fiscalização.** Emitir e revogar é ato da
 * CONTRATANTE (4.75, p.29), mas a ordem obriga a contratada: o prazo de execução corre da entrega
 * ao preposto (6.24.6, p.45) e "indisponibilidade da equipe técnica ao receber a Ordem de Serviço"
 * vale 10 pontos de IAD (ANEXO VIII, item 4, p.157). Esconder a ordem de quem ela obriga seria
 * esconder a obrigação — por isso esta função decide o que aparece, e nunca o que se pode ver.
 *
 * **Isto não é a autorização.** A autorização é `@PreAuthorize(Autorizacoes.FISCAL)` no servidor, e
 * ela vale mesmo se esta função errar. O que se evita aqui é oferecer a alguém um formulário de
 * vinte e quatro campos que o servidor vai recusar no envio.
 *
 * O critério é o de `podeFiscalizar`, e não uma segunda cópia dele: emitir ordem de serviço é o
 * mesmo `@PreAuthorize(Autorizacoes.FISCAL)` que fecha o mês e registra o valor da nota. Esta
 * função continua existindo pelo nome — é ele que diz, na tela da OS, de que ato se está falando.
 *
 * @param usuario quem está usando, ou nulo enquanto o `GET /me` não respondeu
 * @returns verdadeiro quando a pessoa é fiscal ou administrador do lado da Prefeitura
 */
export function podeEscreverOs(usuario: UsuarioLogado | null): boolean {
  return podeFiscalizar(usuario)
}

/**
 * Quem pode consultar os meses descobertos.
 *
 * A faixa vem de `GET /ordens-de-servico/pendencias`, o único endpoint desta tela fechado ao lado
 * CONTRATANTE — o resto é aberto aos dois. Sem esta conferência, quem é da contratada abriria a
 * lista e receberia um 403 no meio de uma tela que funciona.
 *
 * @param usuario quem está usando
 * @returns verdadeiro para qualquer pessoa do lado da Prefeitura, fiscal ou não
 */
export function podeVerPendencias(usuario: UsuarioLogado | null): boolean {
  return usuario?.papelContratual === 'CONTRATANTE'
}
